import Component from './CartItem'
import { withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    'molecules-account-CartItem': {
      molecules_account_cartitem_amountchanger_a11y_decrease_button: void
      molecules_account_cartitem_amountchanger_a11y_amount_input: void
      molecules_account_cartitem_amountchanger_a11y_increase_button: void
      sku_label: {
        SKU_VALUE: string
      }
      num_items: {
        COUNT: string
      }
      delete: void
      energylabel_product_data_sheet: void
      customtailor_form: {
        FORM: string
        VALUE: string
      }
      customtailor_width: {
        WIDTH: string
        VALUE: string
      }
      customtailor_length: {
        LENGTH: string
        VALUE: string
      }
      customtailor_brink: {
        BRINK: string
        WIDTH: string
      }
      customtailor_shape_round: void
      customtailor_shape_square: void
      customtailor_shape_rectangular: void
      customtailor_shape_oval: void
      tax_eco?: void
      for_b2b: void
      for_b2c: void
    }
  }
}

export default withTranslations(Component, () =>
  useStaticQuery(graphql`
    query molecules_account_CartItem_translations {
      molecules_account_cartitem_amountchanger_a11y_decrease_button: snippet(
        group: "molecules-account-CartItem"
        name: "molecules_account_cartitem_amountchanger_a11y_decrease_button"
      )
      molecules_account_cartitem_amountchanger_a11y_amount_input: snippet(
        group: "molecules-account-CartItem"
        name: "molecules_account_cartitem_amountchanger_a11y_amount_input"
      )
      molecules_account_cartitem_amountchanger_a11y_increase_button: snippet(
        group: "molecules-account-CartItem"
        name: "molecules_account_cartitem_amountchanger_a11y_increase_button"
      )
      num_items: snippet(group: "molecules-account-CartItem", name: "num_items")
      customtailor_shape_round: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_shape_round"
      )
      for_b2b: snippet(group: "molecules-account-CartItem", name: "for_b2b")
      for_b2c: snippet(group: "molecules-account-CartItem", name: "for_b2c")

      customtailor_shape_square: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_shape_square"
      )
      customtailor_shape_rectangular: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_shape_rectangular"
      )
      customtailor_shape_oval: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_shape_oval"
      )
      customtailor_form: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_form"
      )
      customtailor_width: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_width"
      )
      customtailor_length: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_length"
      )
      customtailor_brink: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_brink"
      )
      sku_label: snippet(group: "molecules-account-CartItem", name: "sku_label")
      delete: snippet(group: "molecules-account-CartItem", name: "delete")
      tax_eco: snippet(
        group: "molecules-account-CartItem"
        name: "customtailor_shape_round"
      )
    }
  `)
)
